<div class="mb-6"
    [class]="isTemplate()?'w-full p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700':''">
    @if(editable()){
    @if(isTemplate()){
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        <h5 class="mb-2 text-3xl font-bold text-gray-900 dark:text-white">Modifique o campo de veracidade
        </h5>
    </label>
    }
    @if(isTemplate()){
    <div class="container grid grid-cols-1 md:grid-cols-3 gap-4">
        <ui-text placeHolder="Nome ou pergunta" [value]="placeHolder()" [editable]="true"
            (valueChange)="onPlaceholderChange($event)" />
        <ui-true placeHolder="Escolha o valor padrão" [editable]="true" [default]="default()"
            (valueChange)="onDefaultChange($event)" />
    </div>
    } @else{
    <label class="inline-flex items-center cursor-pointer">
        <input type="checkbox" value="" class="sr-only peer" (change)="onChange($event.target)" [checked]="current()"
            [required]="required()">
        <div
            class="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
        </div>
        <span
            class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">{{placeHolder()}}{{required()?'*':''}}</span>
    </label>
        }
    }@else{
    <span for="first_name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"><b>{{placeHolder()}}:</b>
        {{value()?'Sim':'Não'}}</span>
    }
</div>